import { cssRule } from 'typestyle';

cssRule('.tb-site-membership', {
    padding: '6px',
});

cssRule('.tb-site-membership >.tb-picker-container', {
    position: 'relative',
    width: '100%',
    height: '400px',
    marginBottom: '34px',
});

cssRule('.tb-site-membership .tb-dialog-description', {
    width: '100%',
});

